export default function LibraryBooks() {
  return (
    <div className="libraryBooks">
      <figure className="libBookCard">
        <div className="libBookCardDisc fx-cl space2">
          <h4>MID340</h4>
          <p>Lorem, ipsum dolor sit amet consectetur adipisicing.</p>
          <span className="libBookTag">tag: Midwifery</span>
        </div>
        <div className="libBookCardIllustration fx-cl fx-jb space3">
          <span className="fx-ac space1">
            <span>icon</span>
            <span>MCONS-Zuru</span>
          </span>

          <figure className="libBookIllus">Icon Here</figure>
        </div>
      </figure>
    </div>
  );
}
